import React from 'react'
import styled from 'styled-components'
import { colors, md, sans } from '../common'

const PageHead = ({ image, title, subtitle }) => {
  return (
    <Section image={image}>
      <Block>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </Block>
    </Section>
  )
}

export default PageHead

const Section = styled.div`
  margin: 1rem;
  background-image: url(${ props => props.image });
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4rem;

  ${md} {
    padding: 1rem;
    margin: 0;
  }
`

const Block = styled.div`
  width: 70%;
  background-color: ${colors.header};
  margin: auto;
  text-align: center;
  padding: 8rem;
  color: #fff;

  p {
    ${sans};
  }

  ${md} {
    padding: 1rem;
  }

  p {
    font-size: 14px;
    border-top: 1px solid ${colors.brownLight};
    border-bottom: 1px solid ${colors.brownLight};
    padding: 10px;
  }
`
